// import reportFtMergeList from '../components/dataReportMerge/reportFtMergeList.vue'
export default [
    {
        path: 'dataReportMerge/reportFtMergeList',
        component: resolve => require(['@/components/dataReportMerge/reportFtMergeList'],resolve),
        name:'ReportFtMergeList',
        meta:{
            // id:'10009',
            node:'dataReportMerge',
            url:'reportFtMergeList',
        }
    },
    {
        path: 'dataReportMerge/ReportMergeLife',
        component: resolve => require(['@/components/dataReportMerge/ReportMergeLife'],resolve),
        name:'ReportMergeLife',
        meta:{
            // id:'10009',
            node:'dataReportMerge',
            url:'ReportMergeLife',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/dataReportMerge.js